export default __webpack_public_path__ + "static/phone-dd03c9457f3cab07f063d8adba162b23.jpg";